<template>
	<Header theme="primary" logo-align="center">
		<template #left>
			<button v-if="showBack" type="button" class="cancel-header__icon-btn" aria-label="Back" @click="goBack">
				<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M4.17891 6.66421C3.86649 6.97663 3.36008 6.97663 3.04766 6.66421C2.7353 6.35179 2.73526 5.84536 3.04766 5.53296L5.87187 2.70874C6.18427 2.39634 6.6907 2.39639 7.00312 2.70874C7.31554 3.02116 7.31554 3.52757 7.00312 3.83999L4.17891 6.66421ZM7.2375 13.2642C6.94114 13.5919 6.43472 13.6168 6.10703 13.3205L1.37422 9.03999C0.767503 8.49099 1.15589 7.48296 1.97422 7.48296H13.9695C14.4113 7.48296 14.7695 7.84118 14.7695 8.28296C14.7695 8.72479 14.4114 9.08296 13.9695 9.08296H3.80625L7.18047 12.1345C7.50791 12.4309 7.53367 12.9366 7.2375 13.2642Z"
						fill="#00523C"
					/>
				</svg>
			</button>
		</template>
		<template #right>
			<button v-if="showClose" type="button" class="cancel-header__icon-btn" aria-label="Close" @click="$emit('close')">
				<Icon type="ds_close" size="--size-16" />
			</button>
		</template>
	</Header>
</template>

<script setup lang="ts">
// Shared chrome for /cancel/* screens. Centers the Kova logo and optionally
// renders a Back arrow on the left (router back) and/or a Close × on the
// right (emits `close` so the parent decides where to navigate).
// DS doesn't ship an icon-only button variant, so we render a small native
// `<button>` styled to match the Figma frames.
import { Header, Icon } from '@simple-life-app/growth-ui-kova'
import { useRouter } from 'vue-router'

withDefaults(
	defineProps<{
		showBack?: boolean
		showClose?: boolean
	}>(),
	{ showBack: true, showClose: false },
)

const emit = defineEmits<{
	(event: 'close'): void
	/** Fired right before the back navigation — lets screens log a back ButtonClick. */
	(event: 'back'): void
}>()

const router = useRouter()

function goBack() {
	emit('back')
	if (window.history.length > 1) {
		router.back()
	} else {
		router.push('/status')
	}
}
</script>

<style scoped>
.cancel-header__icon-btn {
	appearance: none;
	width: 40px;
	height: 40px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 0;
	background: var(--background-white);
	color: var(--text-dark-primary);
	border: none;
	border-radius: var(--size-16);
	cursor: pointer;
	transition: filter 0.15s ease;
}

.cancel-header__icon-btn:hover {
	filter: brightness(0.96);
}

.cancel-header__icon-btn:active {
	filter: brightness(0.92);
}
</style>
